// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SubscribedPhotoblogs":"sw_a bhi_b bhi_bj","SubscribedPhotoblogs__link":"sw_b bhi_a bhi_r"};